
const handler    = require('./users-page-right-handler')


/****************ELEMENTS*****************/
var HTMLwasSelected  = false
var searchFilter     = ''
const allCharts      = {
         userMultipleUser:      { html:'', chart: '',  },
}

function HTMLselect(detail){ //console.log('goku init>')
	HTMLwasSelected = true
	allCharts.userMultipleUser.html           = document.getElementById('chartMultipleUser')

}/*init*/
/****************ELEMENTS*****************/



export function start(detail){  //console.log('TV page Chart >', detail)
  
   if(!HTMLwasSelected) {HTMLselect(detail)}
	
	 obj[detail.act].start(detail)
}


const obj = {
      createAllChart:  { start: (detail)=>{  handler.createAllChart(detail,allCharts)	}},
      printSystemActivityReport:  { start: ()=>{  handler.printSystemActivityReport()	}},
}/**/





